import { Flex } from "@chakra-ui/react";

export function VisitAssigmentEntityCardError() {
  return <Flex alignItems="center" fontSize="md" h="64px" justify="center" px={5} />;
}
